module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column h-100 justify-content-between pb-2 pt-4"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.disableTooltip),
      expression: "disableTooltip"
    }]
  }, [_c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.rebookDisableValidation
    },
    on: {
      "click": _vm.rebookReservation
    }
  }, [_vm._v("Rebook")]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.cancelBookingDisableValidation
    },
    on: {
      "click": _vm.deleteReservation
    }
  }, [_vm._v("Cancel Booking")]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.sendEmailDisableValidation
    },
    on: {
      "click": _vm.sendTicket
    }
  }, [_vm._v(_vm._s(_vm.isSendingTicket ? 'Sending Email' : 'Send Email'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.disableTooltip),
      expression: "disableTooltip"
    }]
  }, [(_vm.showInvoiceBtn) ? _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    class: {
      'opacity-50 notAllowed': _vm.hasUnsavedChanges
    },
    attrs: {
      "disabled": _vm.invoiceDisableValidation
    },
    on: {
      "click": _vm.startCreateInvoice
    }
  }, [_vm._v(_vm._s(_vm.getIsCreatingInvoice ? 'Invoicing...' : 'Invoice'))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.viewTicketDisableValidation
    },
    on: {
      "click": _vm.viewTicket
    }
  }, [_vm._v(_vm._s(_vm.isGeneratingViewTicket ? 'Generating ticket' : 'View Ticket'))]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-color-1 lightest text-center font-weight-600 py-3 border-light radius-normal pointer",
    attrs: {
      "disabled": _vm.saveDisableValidation
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation({
          printTicket: false,
          closeModal: false
        })
      }
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ca927d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/SideButtons.vue
// module id = 1783
// module chunks = 0